<div class="wrapper mb-5">
    <app-grupo-create-timeline [step]="4"></app-grupo-create-timeline>
    <div class="form-card mt-5">
        <span class="subtitle">Resumo</span>
        <span class="subtitle-gray mt-4">Nome do grupo</span>
        <div class="center-no-padding">
            <span class="group-title">{{rascunho.name}}</span>
            <img class="ml-3 edit" src="./assets/icons/editar.svg" (click)="editarGrupo(editarGrupoModal, rascunho)">
        </div>
        <span class="subtitle-gray">Descrição</span>
        <span class="group-description">{{rascunho.description}}</span>
        <span class="subtitle-gray mt-3">Produtos</span>
        <div *ngFor="let item of rascunho.products">
            <div class="align-center">
                <img class="mr-4 card-icon" [src]="'./assets/icons/produtos/icon-produtos/'+ item.produtoGuid +'.svg'" onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';" alt="{{item.produtoNome}}">
                <div class="row-mobile">
                    <span class="benefit-data">{{item.produtoNome}}</span>
                    <div class="dot"></div>
                </div>
                <div class="row-mobile">
                    <span class="benefit-data">{{getPeriodo(item.standardPeriodCard)}}</span>
                    <div class="dot"></div>
                </div>
                <div class="row-mobile">
                    <div class="benefit-data">{{item.value > 0 ? (item.value | currency:'BRL': true) : 'R$0,00'}}</div>
                    <img class="ml-3 edit" src="./assets/icons/editar.svg" (click)="editarProdutpsGrupo(editarProdutpsGrupoModal, item)">
                </div>
                
            </div>
            <div class="separador mt-4 mb-4"></div>
        </div>
        <div class="row mt-5 align-end">
            <button (click)="finish()" class="white-button">Finalizar</button>
            <button *ngIf="rascunho && !rascunho.isEdicao" (click)="addColaboradores()" class="action-button">Adicionar favorecidos</button>
        </div>
        
    </div>
</div>

<ng-template #editarGrupoModal let-modal>
    <div class="col-12" style="margin-right: 15px;">
        <button id="buttonCloseModal" type="button" class="btn right" style="background-color: #fff; border: none;" (click)="modal.dismiss()">
            <img src="./assets/icons/X.png">
        </button>
    </div>
    <div class="form-card mt-5">
        <label for="group-name">Nome do grupo*</label>
        <input type="text" id="group-name" [(ngModel)]="newGroupName" placeholder="Nome do grupo">
        <span class="hint mt-2">Exemplo: Gerência, Supervisores, Estagiários...</span>
        <label class="mt-4" for="group-description">Descrição</label>
        <input type="text" id="group-description" [(ngModel)]="newGroupDescription" placeholder="Descrição">
        <button (click)="next()" class="action-button mt-5">Próximo</button>
    </div>
</ng-template>

<ng-template #editarProdutpsGrupoModal let-modal>
    <div class="col-12" style="margin-right: 15px;">
        <button id="buttonCloseModal" type="button" class="btn right" style="background-color: #fff; border: none;" (click)="modal.dismiss()">
            <img src="./assets/icons/X.png">
        </button>
    </div>
    <div class="form-card mt-5">
        <span class="subtitle">Configure o produto</span>
        <div class="mt-2 grid-line">
            <div class="quarter">
                <div class="frame">
                    <!-- <img class="white" src="./assets/icons/grupos/beneficios_temp/alimentacao.svg">  -->
                    <!-- ./assets/icons/produtos/icon-produtos/{{this.selectedItem.productGuid}}.svg -->
                    <img class="white" [src]="this.selectedItem.urlIcone">
                    <img class="white" src="https://seuvale-imagens-fixas.s3-sa-east-1.amazonaws.com/Icones-beneficios/Flex.svg"
                    *ngIf="this.selectedItem.produtoId === 9">
                    <span class="label-beneficio mt-3">{{this.selectedItem.produtoNome}}</span>
                </div>
            </div>
            <div class="quarter grid-rows">
                <div class="flex-center mb-4 space-between">
                    <div class="flex-center">
                        <input [attr.id]="selectedItem.standardPeriodCard"
                         type="radio" class="rdButton" [(ngModel)]="standardPeriodType" id="mensal" name="tipo" value="mensal">
                        <label [attr.for]="selectedItem.standardPeriodCard">Mensal</label>
                    </div>
                    <div class="flex-center">
                        <input [attr.id]="standardPeriodType"
                         type="radio" class="rdButton" [(ngModel)]="standardPeriodType" id="diario" name="tipo" value="diario">
                        <label [attr.for]="standardPeriodType" >Diário</label>
                    </div>
                    
                </div>
                <div class="col p-0">
                    <label for="valor-beneficio">Valor:</label>
                    <input name="valor-beneficio" id="valor-beneficio" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                     [(ngModel)]="valorBeneficio" class="input-value"  placeholder="R$ 0,00">
                     
                </div>
            </div>
        </div>
        <button (click)="updateProduct()" class="action-button mt-5">Próximo</button>
    </div>
</ng-template>
